export default __webpack_public_path__ + "static/bg-hero-7540af4bc22625589ac70f1617e82188.jpg";